import { ChakraProvider } from "@chakra-ui/react";
import { ThemeProvider } from "@mui/material/styles";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { Mtheme, theme } from "./theme/index";
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { PostHogProvider } from "posthog-js/react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <PostHogProvider
    apiKey={process.env.REACT_APP_POSTHOG_API_KEY}
    options={{
      host: process.env.REACT_APP_POSTHOG_HOST,
    }}
  >
    <ThemeProvider theme={Mtheme}>
      <PrimeReactProvider>
        <ChakraProvider theme={theme}>
          <App />
        </ChakraProvider>
      </PrimeReactProvider>
    </ThemeProvider>
  </PostHogProvider>
);
